import { useSelector } from 'react-redux'
import { getOrder, getOrderInProgress } from '../../selectors/order'
import { useCallback } from 'react'
import { currentOrderUuid } from '../../utils/orderNumbers'
import { STADIUM_ORDER_STATES } from '../../utils/orderStates'

const useInvoiceNumbers = () => {
  const orderInProgress = useSelector(getOrderInProgress)
  const curUuid = orderInProgress?.uuid || currentOrderUuid()
  const storedOrder = useSelector((state) => getOrder(state, curUuid))

  /**
   * Checks if the current order has an unused invoice number from a previous auth attempt
   */
  const findUnusedInvoiceNumber = useCallback((order) => {
    if (!order || order.isTab) return null

    const isSupportedState = [STADIUM_ORDER_STATES.SUBMITTED, STADIUM_ORDER_STATES.AUTHORIZATION_FAILED].includes(order.state)
    const hasZeroDollarPayment = order.payments?.length === 1 && order.payments[0]?.amountInCents === 0
    const previousInvoiceNumber = order.payments?.[0]?.userAttributes?.freedompayInvoiceNumber

    if (isSupportedState && hasZeroDollarPayment && previousInvoiceNumber?.length >= 10) {
      return previousInvoiceNumber
    }
  }, [])

  /**
   * Previous order attemps can be stored in orderInProgress or order.byId if it's in a split flow
   */
  const getInvoiceNumberFromOrder = useCallback(() => {
    if (!orderInProgress?.payments?.length) {
      if (!storedOrder?.uuid) return null

      return findUnusedInvoiceNumber(storedOrder)
    }

    return findUnusedInvoiceNumber(orderInProgress) || null
  }, [findUnusedInvoiceNumber, orderInProgress, storedOrder])
  return { getInvoiceNumberFromOrder }
}

export default useInvoiceNumbers
